import { assets } from '@yola/ws-sdk';

const copyExtensionAsset = async (iconSrc) => {
  const source = await assets.helpers.copyFromCdn(iconSrc);
  return source;
};

export default copyExtensionAsset;
